import React from "react";
import { Link } from "react-router-dom";
import { Book } from "react-bootstrap-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from "prop-types";
const WeeklyOff = ({
  onSubmit,
  selectedRow,
  attendance,
  hasApproved,
  hasReviewed,
}) => {
  const weeklyOffHandler = () => {
    const selectedEmployees = attendance.filter((a) =>
      selectedRow.includes(a.id),
    );
    console.log("Selected Employees for Weekly Off:", selectedEmployees);
  };
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="weekly-off-tooltip">
          {selectedRow.length === 0
            ? "No Employee Selected"
            : hasApproved || hasReviewed
              ? "Attendance Already Approved or Reviewed"
              : "Mark Weekly Off"}
        </Tooltip>
      }
    >
      <button
        type="button"
        className="btn btn-added"
        onClick={hasApproved || hasReviewed || selectedRow.length === 0 ? null : weeklyOffHandler}
        style={{ height: "30px" }}
        // disabled={hasApproved || hasReviewed || selectedRow.length === 0}
      >
        <Book className="me-2" size={15} />
        Mark weekly off
      </button>
    </OverlayTrigger>
  );
};

WeeklyOff.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  selectedRow: PropTypes.array.isRequired,
  attendance: PropTypes.array.isRequired,
  hasApproved: PropTypes.bool.isRequired,
  hasReviewed: PropTypes.bool.isRequired,
};
export default WeeklyOff;
